import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/common';
import { UiStore } from '@pt/services';

@Component({
  selector: 'aa-header-controls',
  templateUrl: './controls.component.html',
  styleUrls: ['./controls.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonModule, IconModule],
})
export class ControlsComponent {
  readonly uiStore = inject(UiStore);

  toggleTheme(): void {
    this.uiStore.isDarkTheme.update(state => !state);
  }
}
